// Ключи — те же, что ALL_PERMISSION_KEYS в @proschool/core. Подписи и группы — UI CRM.

export const PERMISSION_KEYS = [
  "dash.view",
  "dash.finance",
  "branch.all",
  "students.view",
  "students.edit",
  "students.archive",
  "students.phone",
  "groups.view",
  "groups.edit",
  "schedule.edit",
  "attendance.mark",
  "attendance.all",
  "attendance.override",
  "teachers.view",
  "teachers.edit",
  "teachers.approve",
  "leads.view",
  "leads.edit",
  "fin.payments",
  "fin.debts",
  "fin.expense",
  "fin.salary",
  "fin.report",
  "fin.writeoff",
  "fin.reconcile",
  "fin.expense.entry",
  "notify.view",
  "notify.send",
  "notify.tpl",
  "set.catalog",
  "set.users",
  "set.roles",
  "set.integr",
  "set.audit",
  "fin.export",
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];

export const PERMISSION_LABELS: Record<PermissionKey, string> = {
  "dash.view": "Просмотр дашборда",
  "dash.finance": "Финансовые KPI на дашборде",
  "branch.all": "Все филиалы",
  "students.view": "Просмотр учеников",
  "students.edit": "Редактирование учеников",
  "students.archive": "Архивация учеников (каникулы/уход)",
  "students.phone": "Просмотр телефонов учеников",
  "groups.view": "Просмотр групп и расписания",
  "groups.edit": "Редактирование групп",
  "schedule.edit": "Редактирование расписания",
  "attendance.mark": "Отметка посещаемости своих групп",
  "attendance.all": "Отметка посещаемости всех групп",
  "attendance.override": "Перезапись отметок учителя (админ)",
  "teachers.view": "Просмотр преподавателей",
  "teachers.edit": "Редактирование преподавателей",
  "teachers.approve": "Подтверждение заявок преподавателей",
  "leads.view": "Просмотр заявок",
  "leads.edit": "Редактирование заявок",
  "fin.payments": "Приём оплат",
  "fin.debts": "Задолженности",
  "fin.expense": "Расходы",
  "fin.salary": "Зарплаты",
  "fin.report": "Отчёт P&L",
  "fin.writeoff": "Списание долгов",
  "fin.reconcile": "Сверка кассы",
  "fin.expense.entry": "Ввод расходов (админ)",
  "notify.view": "Просмотр уведомлений",
  "notify.send": "Отправка рассылок",
  "notify.tpl": "Редактирование шаблонов и автоправил",
  "set.catalog": "Настройки справочников",
  "set.users": "Управление пользователями",
  "set.roles": "Управление правами ролей",
  "set.integr": "Управление интеграциями",
  "set.audit": "Журнал аудита",
  "fin.export": "Экспорт финансов",
};

export const PERMISSION_GROUPS: { title: string; keys: PermissionKey[] }[] = [
  { title: "Дашборд", keys: ["dash.view", "dash.finance", "branch.all"] },
  { title: "Ученики", keys: ["students.view", "students.edit", "students.archive", "students.phone"] },
  { title: "Группы и расписание", keys: ["groups.view", "groups.edit", "schedule.edit"] },
  { title: "Посещаемость", keys: ["attendance.mark", "attendance.all", "attendance.override"] },
  { title: "Преподаватели", keys: ["teachers.view", "teachers.edit", "teachers.approve"] },
  { title: "Заявки", keys: ["leads.view", "leads.edit"] },
  { title: "Финансы", keys: ["fin.payments", "fin.debts", "fin.expense", "fin.salary", "fin.report", "fin.writeoff", "fin.reconcile", "fin.expense.entry", "fin.export"] },
  { title: "Уведомления", keys: ["notify.view", "notify.send", "notify.tpl"] },
  { title: "Настройки", keys: ["set.catalog", "set.users", "set.roles", "set.integr", "set.audit"] },
];
